module.exports = __webpack_public_path__ + "static/media/40.0c53a268.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/40.svg
// module id = 150
// module chunks = 0